import * as i0 from '@angular/core';
import { Component, Injectable, NgModule } from '@angular/core';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import * as i1 from '@ng-bootstrap/ng-bootstrap';
import { NgbModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

class LoadingComponent {
    constructor(activeModal) {
        this.activeModal = activeModal;
        this.faSpinner = faSpinner;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.3", ngImport: i0, type: LoadingComponent, deps: [{ token: i1.NgbActiveModal }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.3", type: LoadingComponent, selector: "dp-loading", ngImport: i0, template: "<div class=\"d-flex justify-content-center dp-loading\">\n    <img src=\"assets/icons/loading.svg\" style=\"height: 30vh; position: relative; top: 28vh;\" alt=\"\">\n</div>\n" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.3", ngImport: i0, type: LoadingComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dp-loading', template: "<div class=\"d-flex justify-content-center dp-loading\">\n    <img src=\"assets/icons/loading.svg\" style=\"height: 30vh; position: relative; top: 28vh;\" alt=\"\">\n</div>\n" }]
        }], ctorParameters: () => [{ type: i1.NgbActiveModal }] });

class LoadingService {
    constructor(modal) {
        this.modal = modal;
        this.loadingCounter = 0;
    }
    open() {
        if (!this.currentModal) {
            this.currentModal = this.modal.open(LoadingComponent, {
                backdrop: 'static',
                keyboard: false,
                fullscreen: true,
                modalDialogClass: 'dp-loading'
            });
        }
        this.loadingCounter++;
    }
    close(closeAll) {
        this.loadingCounter--;
        if (this.currentModal && (closeAll || this.loadingCounter < 1)) {
            this.currentModal.dismiss();
            this.currentModal = undefined;
            this.loadingCounter = 0;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.3", ngImport: i0, type: LoadingService, deps: [{ token: i1.NgbModal }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.3", ngImport: i0, type: LoadingService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.3", ngImport: i0, type: LoadingService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1.NgbModal }] });

class LoadingModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.3", ngImport: i0, type: LoadingModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.3", ngImport: i0, type: LoadingModule, declarations: [LoadingComponent], imports: [CommonModule,
            FontAwesomeModule,
            NgbModule], exports: [LoadingComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.3", ngImport: i0, type: LoadingModule, providers: [NgbModal], imports: [CommonModule,
            FontAwesomeModule,
            NgbModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.3", ngImport: i0, type: LoadingModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [LoadingComponent],
                    imports: [
                        CommonModule,
                        FontAwesomeModule,
                        NgbModule
                    ],
                    providers: [NgbModal],
                    exports: [LoadingComponent]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { LoadingComponent as DpLoadingComponent, LoadingModule as DpLoadingModule, LoadingService as DpLoadingService };
